import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import GlobalSearchBar from './GlobalSearchBarComponent';

import {
  isFetchingCategoryHistory,
  isFetchingHistory,
  getHistory,
  getCategoryHistory,
  getInputText,
  onInput,
  getSeletedType,
  onSelect,
  fetchSearchBarCategoryHistory,
  fetchSearchBarHistory,
  getShowHistory,
  setShowHistory
} from './store/action';

const mapStateToProps = state => ({
  isFetchingCategoryHistory: isFetchingCategoryHistory(state),
  isFetchingHistory: isFetchingHistory(state),
  categoryHistory: getCategoryHistory(state),
  history: getHistory(state),
  inputText: getInputText(state),
  selected: getSeletedType(state),
  showHistory: getShowHistory(state)
});

const mapDispatchToProps = dispatch => ({
  fetchSearchBarCategoryHistory: bindActionCreators(
    fetchSearchBarCategoryHistory,
    dispatch
  ),
  fetchSearchBarHistory: bindActionCreators(fetchSearchBarHistory, dispatch),
  onInput: bindActionCreators(onInput, dispatch),
  onSelect: bindActionCreators(onSelect, dispatch),
  setShowHistory: bindActionCreators(setShowHistory, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(GlobalSearchBar);



// WEBPACK FOOTER //
// ./src/features/common/GlobalSearchBar/GlobalSearchBarContainer.js